// Single source of truth for Velcor contact numbers.
// Update here only — every WhatsApp / phone link across the site reads from this file.

// WhatsApp Business line (used for chat links).
export const WHATSAPP_NUMBER = "17132329748"; // (713) 232-9748
export const WHATSAPP_NUMBER_DISPLAY = "(713) 232-9748";

// Branded toll-free number (used for tel: links and visible "call us" labels).
export const BRAND_PHONE_NUMBER = "18007156516"; // (800) 715-6516
export const BRAND_PHONE_DISPLAY = "(800) 715-6516";

/**
 * Build a wa.me deep link with an optional pre-filled message.
 * @param {string} [message] Plain text message — will be URL encoded automatically.
 * @returns {string} wa.me URL
 */
export function whatsappLink(message) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}

/**
 * tel: link for the branded customer-service number.
 */
export function brandPhoneLink() {
  return `tel:+${BRAND_PHONE_NUMBER}`;
}
